module.exports = __webpack_public_path__ + "static/media/devices.d792b60e.yaml";


//////////////////
// WEBPACK FOOTER
// ./src/data/devices.yaml
// module id = 545
// module chunks = 0